import React from 'react';
import styled from 'styled-components';

const TopBar = styled.div`
  background-color: #222;
  padding: 20px;
  color: #fff;
  h2 {
    color: #fff;
    margin-bottom: 0;
  }
`;

const Header = () => (
  <TopBar>
    <h2>Sample 3D Viewer</h2>
  </TopBar>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js